// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import styled from 'styled-components'
import { Flex } from '@teamnine/pcj-ui-v2'

export const Wrapper = styled(Flex)`
  && .nextgen-btn {
    padding-left: 0;
  }

  && .nextgen-btn__content {
    padding-left: 0;
  }

  && .nextgen-btn__children {
    padding-left: 0;
  }
`
